import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';
import { FaFacebook, FaInstagram, FaTiktok, FaYoutube } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="footer-container">
            <div className="footer-content">
                <div className="footer-columns">
                    <div className="footer-column">
                        <h3>Ayuda</h3>
                        <Link to="/preguntas-frecuentes" className="footer-link">Preguntas Frecuentes</Link>
                        <Link to="https://wa.me/+593987608235?text=Hola" className="footer-link">Atención al Cliente</Link>
                    </div>
                    <div className="footer-column">
                        <h3>Términos</h3>
                        <Link to="https://laofi.work/politica-de-privacidad" className="footer-link">Términos y Condiciones</Link>
                        <Link to="https://laofi.work/politica-de-privacidad" className="footer-link">Privacidad y Cookies</Link>
                    </div>
                    <div className="footer-column">
                        <h3>Información</h3>
                        <Link to="https://laofi.work/about-us" className="footer-link">Sobre laofi.work</Link>
                        <Link to="https://laofi.work/trabajo" className="footer-link">Cómo trabajamos</Link>
                        <Link to="https://laofi.work/contact-us" className="footer-link">Contacto</Link>
                        <Link to="https://laofi.work/contacto" className="footer-link">Trabaja con nosotros</Link>
                    </div>
                </div>

                <div className="footer-social">
                    <a href="https://www.facebook.com/LaOfi.work/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook /></a>
                    <a href="https://www.instagram.com/laofi.work/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
                    <a href="https://www.tiktok.com/@laofi.work?lang=es" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><FaTiktok /></a>
                    <a href="https://www.youtube.com/@LaOfiWork" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
                </div>

                <div className="footer-bottom">
                    <p>&copy; 2025 LaOfi. Todos los derechos reservados.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
